// src/components/IterationDialog.tsx
import React, { useState, useEffect } from 'react';
import { Dialog } from './ui/components';
import { EnhancedDropdown } from './ui/components/EnhancedDropdown';
import { usePromptTemplates } from '~/hooks';
import { useTranslation } from 'react-i18next';

interface IterationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (templateId: string, direction: string) => void;
}

export const IterationDialog: React.FC<IterationDialogProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const { getTemplateOptionsByType } = usePromptTemplates();

  const [selectedTemplateId, setSelectedTemplateId] = useState('');
  const [iterationDirection, setIterationDirection] = useState('');

  // 获取迭代类型的模板选项
  const iterateTemplateOptions = getTemplateOptionsByType('iterate');

  // 组件挂载时设置默认模板
  useEffect(() => {
    if (isOpen) {
      // 使用第一个选项
      if (iterateTemplateOptions.length > 0) {
        setSelectedTemplateId(iterateTemplateOptions[0].value);
      }
    }
  }, [isOpen, iterateTemplateOptions]);

  const handleSubmit = () => {
    if (selectedTemplateId && iterationDirection.trim()) {
      onSubmit(selectedTemplateId, iterationDirection);
      // 重置状态
      setIterationDirection('');
      onClose();
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      clickOutside={false}
      title={t('promptBooster.iterationDialog.title')}
      maxWidth="max-w-xl"
      onCancel={onClose}
      onConfirm={handleSubmit}
      cancelText={t('common.buttons.cancel')}
      confirmText={t('common.buttons.confirm')}
      confirmDisabled={!selectedTemplateId || !iterationDirection.trim()}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2 input-description" htmlFor='iteration-template-select'>
            {t('promptBooster.iterationDialog.selectTemplate')}
          </label>
          <EnhancedDropdown
            id="iteration-template-select"
            options={iterateTemplateOptions}
            value={selectedTemplateId}
            onChange={setSelectedTemplateId}
            placeholder={t("promptBooster.templatePlaceholder")}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2 input-description" htmlFor='iterationDirection'>
            {t('promptBooster.iterationDialog.enterDirection')}
          </label>
          <textarea
            id='iterationDirection'
            className="w-full p-3 border rounded-lg focus:outline-hidden input-textarea autoscroll-border"
            placeholder={t('promptBooster.iterationDialog.directionPlaceholder')}
            value={iterationDirection}
            onChange={(e) => setIterationDirection(e.target.value)}
            rows={5}
          />
        </div>
      </div>
    </Dialog>
  );
};